import React from "react";
import { Button } from "@material-ui/core";
import { useStyles } from "../button.module";
import MFAButtonLogic from "./buttonMFA.logic";

const MFAButton = (props) => {
  const classes = useStyles();
  const { values } = MFAButtonLogic(props);
  const { mode = "normal" } = props;

  return (
    <Button
      variant="outlined"
      className={classes[values.buttonClass]}
      type={values.buttonType}
      disabled={props.disabled}
      onClick={props.onClick}
      endIcon={mode === "form" ? values.endIcon : null}
      href={mode === "form" ? values.href : null}
      target={mode === "form" ? values.target : null}
      style={
        mode === "form"
          ? { display: "inline-flex", lineHeight: 1, padding: "0px 10px" }
          : {}
      }
    >
      {props.text || props.children}
    </Button>
  );
};

export default MFAButton;
